<!-- TODO (GB-7600): add shared translations -->
<div class="flex-row">
  <span class="flex-row flex-align-center px-gap-10" matSnackBarLabel>
    <mat-icon>wifi_off</mat-icon>No Internet Connection</span
  >

  <span matSnackBarActions>
    <button mat-button matSnackBarAction (click)="onReload()" [disabled]="isLoading">
      <mat-spinner *ngIf="isLoading; else label" diameter="24"></mat-spinner>
      <ng-template #label> Try Again </ng-template>
    </button>
  </span>
</div>
